// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import Finito from "./../../services/finito-service";
import BaoDialog from "./../../factories/bao-dialog";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/foreach-selection";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-searcher";
function OrgUnitFolderStructureChecklistViewModel(tabPage, orgUnitViewModel) {
    var self = this;
    self.TabPage = tabPage;
    self.OrgUnitViewModel = orgUnitViewModel;
    self.Selection = ko.observableArray();
    self.SelectedFolderStructureChecklists = ko.observableArray();
    self.Sorting = ko.observableArray();
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.TotalRows = ko.observable();
    self.Models = ko.observableArray([]);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.Selection.subscribe(function () {
        self.toggleButtons();
    });
    self.SelectedFolderStructureChecklists.subscribe(function (selectedItems) {
        if (selectedItems != null && selectedItems.length > 0) {
            var folderStructureChecklistIds = [];
            ko.utils.arrayForEach(selectedItems, function (item: any) {
                folderStructureChecklistIds.push(ko.unwrap(item.FolderStructureChecklistId));
            });
            self.addFolderStructureChecklistToSession(folderStructureChecklistIds);
        }
    });
    self.toolbarButtonClicked = function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            var functionString = btn.ActionKey().substr(("OrgUnitCustomToolbarFolderStructureChecklist").length);
            switch (functionString) {
                case "Add":
                    self.addFolderStructureChecklist();
                    break;
                case "Remove":
                    var promptDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("DeleteOrgUnitFolderStructureChecklist"), "question");
                    promptDialog.DialogResult.subscribe(function (res) {
                        if (res) {
                            self.removeFolderStructureChecklist();
                        }
                    });
                    break;
                default:
                    break;
            }
        }
    };
    self.toolbarLoaded = function () {
        self.toggleButtons();
    };
    self.addFolderStructureChecklist = function (item) {
        this.openFolderStructureChecklistSearcher();
    };
    self.openFolderStructureChecklistSearcher = function () { };
}
;
OrgUnitFolderStructureChecklistViewModel.prototype.toggleButtons = function () {
    if (this.enableButton != undefined) {
        var selection = this.Selection.peek();
        this.enableButton("OrgUnitCustomToolbarFolderStructureChecklistRemove", selection && selection.length > 0);
    }
};
OrgUnitFolderStructureChecklistViewModel.prototype.removeFolderStructureChecklist = function (a, b, c) {
    var self = this;
    self.TabPage.IsLoading(true);
    var folderStructureChecklistIds = [];
    ko.utils.arrayForEach(self.Selection(), function (item: any) {
        folderStructureChecklistIds.push(ko.unwrap(item.FolderStructureChecklistId));
    });
    return Bao.post("OrgUnit/DeleteFolderStructureChecklist", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId(),
        orgUnitId: self.OrgUnitViewModel.OrgUnitId(),
        folderStructureChecklistIds: folderStructureChecklistIds
    }), function () {
        self.OrgUnitViewModel.TabPage.DirtyFlag(true);
        self.RefreshGrid();
    });
};
OrgUnitFolderStructureChecklistViewModel.prototype.RefreshGrid = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("OrgUnit/GetFolderStructureChecklist", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId(),
        orgUnitId: self.OrgUnitViewModel.OrgUnitId(),
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting()
    }), function (searchResult) {
        self.SelectedFolderStructureChecklists([]);
        self.TotalRows(0);
        self.Models([]);
        if (searchResult != null && searchResult.Models != null) {
            self.Models(searchResult.Models);
            self.TotalRows(searchResult.TotalRows);
            self.toggleButtons();
        }
        self.TabPage.IsLoading(false);
    });
};
OrgUnitFolderStructureChecklistViewModel.prototype.Refresh = function () {
    var self = this;
    var def = $.Deferred();
    self.Selection([]);
    Bao.post("OrgUnit/ResetOrgUnitFolderStructureChecklist", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId()
    }), function () {
        self.RefreshGrid().then(function () {
            def.resolve();
        });
    });
    return def.promise();
};
OrgUnitFolderStructureChecklistViewModel.prototype.addFolderStructureChecklistToSession = function (folderStructureChecklistIds) {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("OrgUnit/AddFolderStructureChecklist", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId(),
        orgUnitId: self.OrgUnitViewModel.OrgUnitId(),
        folderStructureChecklistIds: folderStructureChecklistIds
    }), function () {
        self.OrgUnitViewModel.TabPage.DirtyFlag(true);
        self.RefreshGrid();
    });
};
export default OrgUnitFolderStructureChecklistViewModel;